import { TrophyLineIcon } from 'assets/icons';
import Tooltip from 'components/tooltips/Tooltips';
import { toneClass } from './statsFormat';

// The gap with the period before, coloured by its direction.
export const Delta = ({ delta }) =>
  delta ? (
    <span className={`text-xs font-medium leading-4 ${toneClass(delta.tone)}`}>
      {delta.text}
    </span>
  ) : null;

const GRIDS = {
  // The statistics page: six tiles on a row on a wide screen.
  page: 'grid grid-cols-2 gap-3 tab:grid-cols-3 xl:grid-cols-6',
  // A company's page, narrower: three tiles a row at most.
  record: 'mt-2 grid grid-cols-2 gap-3 tab:grid-cols-3',
};

/**
 * The tiles of « Résultats », shared by the statistics page and a company's
 * page: `tiles` are { key, icon, value, delta, label, note, noteHint, goal },
 * `note` a grey line under the label, `goal` (with a trophy) what the agency
 * manager aims at.
 */
const ResultTiles = ({ tiles, layout = 'page', goalLabel = () => '' }) => (
  <div className={GRIDS[layout]}>
    {tiles.map(
      ({
        key,
        icon: Icon,
        value,
        delta,
        label,
        note,
        noteHint,
        goal,
        formatGoal = String,
      }) => (
        <div
          key={key}
          className="flex min-w-0 flex-col items-start gap-2 rounded-2xl border border-gray-100 bg-white p-4"
        >
          <span className="flex size-8 items-center justify-center rounded-2xl bg-gray-100 text-gray-600">
            <Icon wh={16} color="currentColor" />
          </span>
          <p className="flex items-baseline gap-2 whitespace-nowrap">
            <span className="text-xl font-bold leading-[26px] tracking-[-0.4px] text-gray-900">
              {value}
            </span>
            <Delta delta={delta} />
          </p>
          <p className="text-xs leading-4 text-gray-600">{label}</p>
          {goal != null && (
            <p
              className="-mt-1.5 flex items-center gap-1 text-xs leading-4 text-gray-400"
              aria-label={goalLabel(formatGoal(goal))}
            >
              <TrophyLineIcon wh={12} color="currentColor" />
              {formatGoal(goal)}
            </p>
          )}
          {note && (
            <Tooltip text={noteHint} disabled={!noteHint} placement="bottom">
              <p className="-mt-1.5 cursor-default text-xs leading-4 text-gray-400">
                {note}
              </p>
            </Tooltip>
          )}
        </div>
      ),
    )}
  </div>
);

export default ResultTiles;
